import React, { PureComponent } from 'react';

export default class SpinningGear extends PureComponent {
	static defaultProps = {
		className: ''
	};

	render() {
		const { className } = this.props;
		return (
			<i className={`fa fa-cog fa-spin ${className}`} />
		);
	}
}